import { render, staticRenderFns } from "./BlankPresentation.vue?vue&type=template&id=1637c14a&scoped=true"
import script from "./BlankPresentation.vue?vue&type=script&lang=js"
export * from "./BlankPresentation.vue?vue&type=script&lang=js"
import style0 from "./BlankPresentation.vue?vue&type=style&index=0&id=1637c14a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1637c14a",
  null
  
)

export default component.exports